import React from "react";
import {connect} from "react-redux";
import "./DownloadManager.css";
import Hash from "object-hash";
import {TableData, TableRow} from "../../../ResultTable/Components/ResultRow/StyledResultRow";
import DocumentDownload from "../../../../../Download/Entity/DocumentDownload";
import {DownloadState} from "../../../../../Download/Reducer/Download";
import Progress from "../../../../../Download/ValueObject/Progress";

type DownloadManagerRowProps = {
    document: DocumentDownload;
    index: number;
}

const DownloadManagerRowProgress = (props: DownloadManagerRowProps & mapStateToPropsType) => {
    const {document, index, progress} = props;
    const rowId: string = Hash(document) + "-progress";
    const positionClassName: string = index % 2 === 0 ? "even" : "odd";
    const tableRowClassName: string = document.getStatus() + " progress-wrapper " + positionClassName;

    return (
        <TableRow id={rowId} className={tableRowClassName} style={{color: "#fff"}}>
            <TableData colSpan={4} className={"accordionWrapper"}>
                {!progress.isEmpty() && <div className={'progressResult'}>
                    <span>{progress.getSize()}</span>
                    <span>{progress.getDownloaded()}</span>
                    <span>{progress.getSpeed()}</span>
                    <span>{progress.getTime()}</span>
                </div>}
                <div className={'open accordion'}>
                    <div className="progress">
                        <div className="progress-bar" style={{width: progress.getProgress() + "%"}}/>
                    </div>
                </div>
            </TableData>
        </TableRow>
    );
}

type DownloadManagerRowProgressStageProps = {
    download: DownloadState
}

type mapStateToPropsType = {
    progress: Progress
}

const mapStateToProps = (state: DownloadManagerRowProgressStageProps): mapStateToPropsType => (
    {
        progress: state.download.progress
    }
);

export default connect(mapStateToProps, {})(DownloadManagerRowProgress);
